<template>
    <el-form
        ref="stepForm"
        :model="formData"
        :rules="rules"
    >
        <el-row :gutter="15">
            <el-col
                :span="24"
                class="form-step-title"
            >
                <div class="steptitle">
                    {{ stepTitle }}
                </div>
                <el-checkbox
                    v-if="formData['sameAsApplicant'] !== undefined"
                    v-model="formData['sameAsApplicant']"
                >
                    Same as applicant details
                </el-checkbox>
                <div v-else>
&nbsp;
                </div>
            </el-col>
            <el-col
                v-for="(val, field, j) in value"
                :key="'validation_g' + j"
            >
                <el-form-item
                    v-if="field == 'gender'"
                    :prop="field"
                >
                    <div style="width: 100%">
                        <el-radio
                            v-model="formData[field]"
                            label="mr"
                        >
                            Mr.
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            label="mrs"
                        >
                            Mrs.
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            label="ms"
                        >
                            Ms.
                        </el-radio>
                    </div>
                </el-form-item>
            </el-col>
            <el-col
                v-for="(val, field, i) in value"
                :key="'validation' + i"
                :sm="24"
                :md="12"
            >
                <el-form-item
                    v-if="field == 'applying_as'"
                    :prop="field"
                >
                    <label
                        class="el-form--label-top"
                    >{{ __("fieldnames." + formName + "." + field) }}*
                    </label>
                    <div style="width: 100%">
                        <el-radio
                            v-model="formData[field]"
                            label="designer"
                        >
                            Designer
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            label="manufacturer"
                        >
                            Manufacturer
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            label="pr_agency"
                        >
                            PR Agency
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            label="architect"
                        >
                            Architect
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            label="other"
                        >
                            Other
                        </el-radio>
                    </div>
                </el-form-item>
                <div v-else-if="field == 'sameAsApplicant'" />
                <el-form-item
                    v-else-if="field == 'newsletter'"
                    :prop="field"
                >
                    <label
                        class="el-form--label-top"
                    >{{ __("fieldnames." + formName + "." + field) }}*
                    </label>
                    <div style="width: 100%">
                        <el-radio
                            v-model="formData[field]"
                            :label="1"
                        >
                            Yes
                        </el-radio>
                        <el-radio
                            v-model="formData[field]"
                            :label="0"
                        >
                            No
                        </el-radio>
                    </div>
                </el-form-item>
                <el-form-item
                    v-else-if="field == 'country'"
                    :prop="field"
                >
                    <InputWh
                        v-model="formData[field]"
                        :placeholder="field"
                        :options="countryOptions"
                        field-type="select"
                        :required="rules[field][0].required"
                        :disabled="isSame"
                        :form-name="formName"
                        :form-step="step"
                        @change="formData.state_region = ''"
                    />
                </el-form-item>
                <template v-else-if="field == 'state_region'">
                    <el-form-item
                        v-if="
                            currentStateOptions != {} &&
                                currentStateOptions.length != 0
                        "
                        :prop="field"
                    >
                        <InputWh
                            v-model="formData[field]"
                            :placeholder="field"
                            :options="currentStateOptions"
                            field-type="select"
                            :required="rules[field][0].required"
                            :disabled="isSame"
                            :form-name="formName"
                            :form-step="step"
                        />
                    </el-form-item>
                    <div
                        v-else
                        class="emptyfield"
                    >
&nbsp;
                    </div>
                </template>
                <el-form-item
                    v-else-if="field == 'category'"
                    :prop="field"
                >
                    <InputWh
                        v-model="formData[field]"
                        :placeholder="field"
                        :options="categoryOptions"
                        field-type="select"
                        :required="rules[field][0].required"
                        :form-name="formName"
                        :form-step="step"
                        @change="formData.subcategory = ''"
                    />
                </el-form-item>
                <template v-else-if="field == 'subcategory'">
                    <el-form-item :prop="field">
                        <InputWh
                            v-model="formData[field]"
                            :placeholder="field"
                            :options="subCategoryOptions[formData.category]"
                            field-type="select"
                            :form-name="formName"
                            :form-step="step"
                            :required="rules[field][0].required"
                        />
                    </el-form-item>
                </template>
                <el-form-item
                    v-else-if="field == 'year_of_production'"
                    :prop="field"
                >
                    <InputWh
                        v-model="formData[field]"
                        :placeholder="field"
                        :options="yearOptions"
                        field-type="select"
                        :required="rules[field][0].required"
                        :form-name="formName"
                        :form-step="step"
                    />
                </el-form-item>
                <el-form-item
                    v-else-if="field == 'phone_number'"
                    :prop="field"
                >
                    <vue-tel-input
                        v-model="formData[field]"
                        default-country="US"
                        valid-characters-only
                        :input-options="{ showDialCode: true, tabindex: 0 }"
                        :required="rules[field][0].required"
                        :disabled="isSame"
                    />
                </el-form-item>
                <!--<el-form-item :prop="field" v-else-if="field == 'phone_number'">
                    <VuePhoneNumberInput
                        v-model="formData[field]"
                        no-example
                        :required="rules[field][0].required"
                        :disabled="isSame"
                        color="#606266"
                    />
                </el-form-item>-->
                <el-form-item
                    v-if="
                        field != 'gender' &&
                            field != 'newsletter' &&
                            field != 'phone_number' &&
                            field != 'applying_as' &&
                            field != 'project_description' &&
                            field != 'floorplans' &&
                            field != 'video_link' &&
                            field != 'images' &&
                            field != 'year_of_production' &&
                            field != 'category' &&
                            field != 'subcategory' &&
                            field != 'state_region' &&
                            field != 'country' &&
                            field != 'sameAsApplicant'
                    "
                    :prop="field"
                >
                    <InputWh
                        v-model="formData[field]"
                        :placeholder="field"
                        :disabled="field != 'vat_id' ? isSame : false"
                        :form-name="formName"
                        :form-step="step"
                        :required="rules[field][0].required"
                    />
                </el-form-item>
            </el-col>
        </el-row>
        <template v-if="step == 3">
            <el-row
                v-for="(val, field, k) in value"
                :key="'validation_f' + k"
                :gutter="15"
            >
                <el-form-item
                    v-if="field == 'video_link'"
                    :prop="field"
                >
                    <InputWh
                        v-model="formData[field]"
                        :placeholder="field"
                        :disabled="field != 'vat_id' ? isSame : false"
                        :form-name="formName"
                        :form-step="step"
                        :required="rules[field][0].required"
                    />
                </el-form-item>
                <el-form-item
                    v-if="field == 'images'"
                    :prop="field"
                >
                    <el-form-item>
                        <div class="form-step-title">
                            <div class="steptitle">
                                <b>Project Images - Project Description</b>
                            </div>
                        </div>
                        <div class="upload-pretext">
                            The next two steps are essential for your project
                            application. Images will be used for the jury review.
                            Your project text description will be used on our
                            websites, publications, and exhibition materials. Please
                            submit content and images during your application that
                            accurately represent your project.
                            <b>All steps are mandatory</b>
                        </div>
                    </el-form-item>
                    <div class="field-heading">
                        Project Images Upload *
                    </div>
                    <div class="upload-pretext">
                        <div style="color: #f39200">
                            <b>Drop files or click here to upload 8 to 10 images</b>
                            <br>
                            <br>
                        </div>
                        <b>1. ASPECT RATIO 16:9</b>
                        (1920px Χ 1080px Landscape or Portrait). <br><b>2. ASPECT RATIO 1:1</b>
                        (1080px X 1080px Square format). You can upload images in
                        mixed formats. <br><b>3. RESOLUTION:</b> 300dpi/image, max
                        6MB per file. The file names should use explicitly Latin
                        characters. (Please upload 8-10 images) <br><b>4. FILE TYPE:</b>
                        JPG, PNG.
                    </div>
                    <el-upload
                        ref="uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :multiple="true"
                        :drag="true"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :file-list="formData.images"
                        :auto-upload="false"
                        list-type="picture"
                    >
                        <div class="el-upload__text">
                            Drop files or click here to upload
                            <em>8 - 10 images</em>
                            <div class="upload-icon" />
                        </div>
                    </el-upload>
                    <div class="upload-aftertext">
                        <b>Notice:</b> For more images or 3d renderings and plans
                        please forward directly to us using either through
                        wetransfer or dropbox at contact@globaldesignnews.com
                    </div>
                    <div class="el-form-item__error">
                        {{ filesError }}
                    </div>
                </el-form-item>
            <!--<el-form-item :prop="field" v-else-if="field == 'floorplans'">
                <div class="field-heading">
                    Project Floorplans and Elevations Upload
                </div>
                <div class="upload-pretext">
                    <div style="color:#f39200">
                        <b>Drop pdf or click here to upload up to 1pdf file with all plans and Elevation plans</b>
                        <br />
                        <br />
                    </div>                     
                    <b>1. FILE SIZE:</b>
                    Max 25mb
                    <b>2. FILE TYPE:</b>
                    PDF format.
                </div>
                <el-upload
                    accept="application/pdf"
                    ref="floorplansuploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :multiple="false"
                    :limit="1"
                    :drag="true"
                    :on-change="handleChangeFloorPlansPDF"
                    :on-remove="handleRemoveFloorPlans"
                    :file-list="formData.floorplans"
                    :auto-upload="false"
                >
                <div class="el-upload__text">
                    Drop pdf or click here to upload
                    <em>up to 1 pdf file</em>
                    <div class="upload-icon"></div>
                </div>
                </el-upload>
                <b>Notice:</b> Please upload Plans/Sections/Elevations or blueprints, for the jury procedure.<br><br>
                <div class="el-form-item__error">
                    {{ filesError }}
                </div>
            </el-form-item>-->
            </el-row>
        </template>
        <el-row :gutter="15">
            <el-col
                v-for="(val, field, j) in value"
                :key="'validation_pd' + j"
            >
                <el-form-item
                    v-if="field == 'project_description'"
                    :prop="field"
                >
                    <div class="projectdesc">
                        <div class="field-heading">
                            Project Description (1000 words max)*
                        </div>
                        <el-form-item :prop="field">
                            <InputWh
                                v-model="formData[field]"
                                :placeholder="field"
                                field-type="textarea"
                                :required="rules[field][0].required"
                                :form-name="formName"
                                :form-step="step"
                            />
                            <span
                                class="message-counter"
                            >{{ formData[field].length }} /
                                <span
                                    :style="[
                                        formData[field].length < 5000
                                            ? { color: 'green' }
                                            : { color: 'red' },
                                    ]"
                                >5000</span>
                                max characters</span>
                        </el-form-item>
                    </div>
                    <div class="upload-aftertext">
                        <b>Notice:</b> Please paste your project description
                        text in the box bellow. Description should not extend
                        the 1000 words and it should represent your project
                        describing the idea and all the technical details. We
                        will use part or all of your text for all the website
                        presentations, exhibition materials,publications and
                        social media.
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        <div class="form-buttons">
            <el-button
                v-if="step > 0"
                type="text"
                size="medium"
                icon="el-icon-arrow-left"
                @click="$emit('prevStep')"
            >
                Back
            </el-button>
            <div v-else>
&nbsp;
            </div>
            <el-button @click="handleNextStep()">
                Next
            </el-button>
        </div>
    </el-form>
</template>
<script>
import InputWh from '@/core/components/InputWithHint'
//import VuePhoneNumberInput from "vue-phone-number-input";

export default {
    props: {
        value: {
            type: Object,
            default: () => {
                return {}
            },
        },
        applicant: { type: Object, default: () => ({}) },
        stepTitle: { type: String, default: '' },
        step: { type: Number, default: 0 },
    },
    components: {
        InputWh,
        //VuePhoneNumberInput,
    },
    computed: {
        // Selectable years for "Year of Production"; update every award cycle
        yearOptions: function () {
            return { 2024: 2024, 2025: 2025, 2026: 2026, 2027: 2027 }
        },
        selectedCategoryKey() {
            return this.categoryKeyMap[this.formData.category] || null
        },
        isSame: function () {
            if (this.formData.sameAsApplicant) {
                return true
            }
            return false
        },
        formData: {
            get() {
                return this.value
            },
            set(newVal) {},
        },
    },
    methods: {
        handleNextStep() {
            let self = this
            this.$refs.stepForm.validate((valid) => {
                if (valid) {
                    if (
                        self.formData.images &&
                        self.formData.images.length == 0
                    ) {
                        self.filesError =
                            'You should upload at least one file.'
                    } else {
                        self.$emit('nextStep')
                    }
                } else {
                    alert(
                        'Please correct the form errors before proceeding to the next step.'
                    )
                }
            })
        },
        handleRemove(file, fileList) {
            let newImages = []
            fileList.forEach(function (listFile) {
                newImages.push(listFile)
            })
            this.formData.images = newImages
        },
        handleChange(file, fileList) {
            let self = this
            let sizeLimit = 6 * 1024 * 1024
            let fileSize = file.raw.size
            let fileType = file.raw.type

            self.filesError = ''
            self.$refs.uploader[0].clearFiles()

            const reader = new FileReader()

            reader.onload = function (e) {
                let img = document.createElement('img')
                img.onload = function (event) {
                    // Checked per file: several files selected at once each get here separately
                    let error = ''
                    if (self.formData.images.length > 9) {
                        error =
                            'You cannot upload more than 10 files.'
                    } else if (
                        ['image/jpeg', 'image/jpg', 'image/png'].indexOf(
                            fileType
                        ) < 0
                    ) {
                        error =
                            'The image format should only be JPEG or PNG.'
                    } else if (fileSize > sizeLimit) {
                        error =
                            'The image is too big. It should be at most 6MB.'
                    }

                    if (error) {
                        self.filesError = error
                        // Keep the images already accepted; a new array re-syncs the cleared uploader list
                        self.formData.images = [...self.formData.images]
                        return false
                    }

                    // Dynamically create a canvas element
                    let canvas = document.createElement('canvas')

                    // var canvas = document.getElementById("canvas");
                    let ctx = canvas.getContext('2d')
                    ctx.canvas.width = 100
                    ctx.canvas.height = 100

                    // Actual resizing
                    ctx.drawImage(img, 0, 0, 100, 100)

                    // Show resized image in preview element
                    file.url = canvas.toDataURL(file.raw.type)

                    self.formData.images.push(file)
                }
                img.src = e.target.result
            }

            reader.onerror = function (error) {
                self.filesError =
                    'Oops! That file could not be parsed, please try again.'
            }

            reader.readAsDataURL(file.raw)
        },
        handleRemoveFloorPlans(file, fileList) {
            let newImages = []
            fileList.forEach(function (listFile) {
                newImages.push(listFile)
            })
            this.formData.floorplans = newImages
        },
        handleChangeFloorPlansPDF(file, fileList) {
            let self = this
            self.formData.floorplans.push(file.raw)
        },
        copyApplicantDetails: function () {
            if (this.formData.sameAsApplicant !== undefined) {
                if (this.formData.sameAsApplicant == 1) {
                    let step1values = Object.assign({}, this.applicant)
                    Object.keys(step1values).forEach((key) => {
                        if (this.formData[key] !== undefined) {
                            this.formData[key] = step1values[key]
                        }
                    })
                } else {
                    /*Object.keys(this.formData).forEach(key => {
                        this.formData[key] = '';
                    });*/
                }
            }
        },
    },
    watch: {
        'formData.country': function (newVal, oldVal) {
            let self = this
            if (self.formData.state_region !== undefined) {
                if (newVal && self.stateOptions[newVal]) {
                    self.currentStateOptions = self.stateOptions[newVal]
                }
            }
        },
        step: function (newVal, oldVal) {
            this.copyApplicantDetails()
        },
        'formData.sameAsApplicant': function (newVal, oldVal) {
            this.copyApplicantDetails()
        },
    },
    data: () => ({
        rules: {
            firstname: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            lastname: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            company_name: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            job_title: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            phone_number: [
                {
                    required: true,
                    pattern: /^[0-9._\+\-\(\) ]+$/i,
                    message: 'This field is invalid',
                    trigger: 'blur',
                },
            ],
            fax: [
                {
                    required: false,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            email: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
                {
                    type: 'email',
                    message: 'This field is invalid',
                    trigger: 'blur',
                },
            ],
            web_address: [
                {
                    required: true,
                    message: 'This is not a valid website',
                    trigger: 'blur',
                },
            ],
            address1: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            address2: [
                {
                    required: false,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            country: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            state_region: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            city: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            postcode: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            applying_as: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            gender: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            newsletter: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            category: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            subcategory: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            project_title: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            year_of_production: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            state_country_of_production: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            designer_name: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            manufacturer: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            photographer: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            design_team: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            other: [
                {
                    required: false,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            images: [{ required: true }],
            //floorplans: [{ required: false }],
            video_link: [
                {
                    required: false,
                },
            ],
            project_description: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
                {
                    min: 0,
                    max: 6000,
                    message:
                        'This should be up to 6000 characters (~1000 words)',
                    trigger: 'blur',
                },
            ],
            vat_id: [
                {
                    required: true,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
            sameAsApplicant: [
                {
                    required: false,
                    message: 'This field is required',
                    trigger: 'blur',
                },
            ],
        },
        formName: 'lighting',
        countryOptions: window._countries,
        stateOptions: window._states,
        currentStateOptions: [],
        categoryOptions: {
            Lighting: 'Lighting',
            Furniture: 'Furniture',
        },
        subCategoryOptions: {
            Lighting: {
                'Table Lighting Units': 'Table Lighting Units',
                'Floor Lighting Units': 'Floor Lighting Units',
                'Ceiling Lighting Units': 'Ceiling Lighting Units',
                'Outdoor Lighting Units': 'Outdoor Lighting Units',
                'Wall Lighting Units': 'Wall Lighting Units',
            },
            Furniture: {
                'Seating Units': 'Seating Units',
                'Chair Units': 'Chair Units',
                'Office Chair Units': 'Office Chair Units',
                'Office/Home Desk Units': 'Office/Home Desk Units',
                'Office Pod Units': 'Office Pod Units',
                'Storage Units': 'Storage Units',
                Closets: 'Closets',
                'Table Units': 'Table Units',
                'Wall and Ceiling Partitions': 'Wall and Ceiling Partitions',
                'Built-in-Furniture': 'Built-in-Furniture',
                'Fabric/Textile Units': 'Fabric/Textile Units',
                'Floor and Wallcovering Units': 'Floor and Wallcovering Units',
                'Urban Furniture': 'Urban Furniture',
            },
        },
        filesError: '',
    }),
}
</script>
